import { FC, Dispatch, SetStateAction } from "react";
import { Button, CardHeader, Stack } from "@mui/material";

import { LoginMain } from "../Login";
import { PopupViewer } from "../../molecules";

import { useGetProfileQuery } from "../../../store";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { LoginPopup } from "../../organisms";

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSuccess?: () => void;
}

export const Login: FC<Props> = ({ open, setOpen, onSuccess = () => {} }) => {
  const { isLoggedin } = useTypedSelector(s => s.auth);

  const { data } = useGetProfileQuery(undefined, {
    skip: !isLoggedin,
    refetchOnMountOrArgChange: true,
  });

  return (
    <>
      <Stack gap={2}>
        <CardHeader
          sx={{ p: 0 }}
          title="LOGIN"
          titleTypographyProps={{ variant: "subtitle2", fontWeight: 700 }}
          subheader={
            data ? (data.mobileNumber ? data.mobileNumber : data.emailId) : null
          }
          subheaderTypographyProps={{ variant: "body2" }}
        />
        {!isLoggedin && (
          <Button variant="contained" onClick={() => setOpen(true)}>
            Login/Sign Up
          </Button>
        )}
      </Stack>
      <LoginPopup open={open} setOpen={setOpen} onSuccess={onSuccess} />
    </>
  );
};
